module.exports = __webpack_public_path__ + "static/completesolution-accd5581f2436a41e6a6a15034cb2e00.png";